
















import AbpBase from "@/lib/abpbase";
import { Component,Prop } from "vue-property-decorator";
import  { QueryThresholdSet,DeleteThresholdSet,QueryPatientThreshold,DeletePatientThresholdSet} from "@/api/pdOutPatient/pdBasicInformation"
import addOrEdit from "./addOrEdit.vue"
import patientpush from "./patientpush.vue"
  
@Component({components: {addOrEdit,patientpush}})
export default class extends AbpBase {
  @Prop() patient: any;
  ThresholdList=[];
  addOrEditShow=false;
  patientpushShow=false;
  formData: any = {};
  Threshold =[];
  loading = false;
  totalCount = 0;
  addOrEdittitle="";
  payload = {
    QueryString: "",
    Page: 1,
    PageSize: 10,
  };
  column=[];
  renderConColumns() {
  this.column= [
    {
			key: 'itemCode',
			title: '指标编码'
		},
    {
			key: 'itemName',
			title: '指标名称'
		},
    {
			key: 'minValue',
			title: '最小值'
		},
		{
			key: 'maxValue',
			title: '最大值'
		},
		{
			key: 'maxWarnContent',
			title: '上限提醒内容'
		},
    {
      key: 'minWarnContent',
			title: '下限提醒内容'
    },
  
  ];
  if(this.patient!=null){
    this.column.push({
      key: 'creationTime',
			title: '推送时间',
      minWidth: 140,
      render:(h:any, p:any)=>{
					return h('span', this.formatDateTime(p.row.creationTime))
				}
    },
    {
      key: 'creatorUserName',
			title: '操作人',
    },
    {
      key: '',
			title: '操作',
      render:(h:any, p:any)=>{
        if(this.patient==null){
				return h('div', [
        h('Button',{
						props:{type: 'info'},
						style:{marginRight:'10px'},
						on:{
							click:()=>{
								this.push(p.row)
							}
						}
					},'推送'),
					h('Button',{
						props:{type: 'primary'},
						style:{marginRight:'10px'},
						on:{
							click:()=>{
								this.edit(p.row)
							}
						}
					},'编辑'),
				/*	h('Button',{
						props:{type: 'error'},
						style:{marginRight:'20px'},
						on:{
							click:()=>{
								this.del(p.row)
							}
						}
					},'删除'),*/
				],
        )
			}else{
        return h('div', [
					h('Button',{
						props:{type: 'primary'},
						style:{marginRight:'20px'},
						on:{
							click:()=>{
								this.edit(p.row)
							}
						}
					},'编辑'),
			/*		h('Button',{
						props:{type: 'error'},
						style:{marginRight:'20px'},
						on:{
							click:()=>{
								this.del(p.row)
							}
						}
					},'删除'),*/
				],
        )
      }
    }
    },
    )


  }else{
this.column.push(
  {
      key: '',
			title: '操作',
      render:(h:any, p:any)=>{
        if(this.patient==null){
				return h('div', [
        h('Button',{
						props:{type: 'info'},
						style:{marginRight:'10px'},
						on:{
							click:()=>{
								this.push(p.row)
							}
						}
					},'推送'),
					h('Button',{
						props:{type: 'primary'},
						style:{marginRight:'10px'},
						on:{
							click:()=>{
								this.edit(p.row)
							}
						}
					},'编辑'),
				/*	h('Button',{
						props:{type: 'error'},
						style:{marginRight:'20px'},
						on:{
							click:()=>{
								this.del(p.row)
							}
						}
					},'删除'),*/
				],
        )
			}else{
        return h('div', [
					h('Button',{
						props:{type: 'primary'},
						style:{marginRight:'20px'},
						on:{
							click:()=>{
								this.edit(p.row)
							}
						}
					},'编辑'),
			/*		h('Button',{
						props:{type: 'error'},
						style:{marginRight:'20px'},
						on:{
							click:()=>{
								this.del(p.row)
							}
						}
					},'删除'),*/
				],
        )
      }
    }
    }
)
  }
  }
  created() {
    this.renderConColumns();
    this.getData();
  }
  /*query() {
    this.getData();
  }

  handlePageChange(val: any) {
    this.payload.Page = val;
    this.query();
  }*/
  addOrEditShowChange() {
			this.addOrEditShow = false
			this.getData()
		}
  async getData(){
    this.loading = true;
    if(this.patient==null){
    let res =await QueryThresholdSet();
    this.ThresholdList  = res.objects;
    }else{
    let res = await QueryPatientThreshold({PD_Patient_ID:this.patient.pD_Patient_ID});
    this.ThresholdList =res.objects;
    }
    this.loading = false;
  }
  push(row:any){
    this.Threshold.push(row);
    this.formData = {
      model: this.Threshold,
      itemcode:row.itemCode,
      title: row.itemName+"指标推送"
    };
    this.patientpushShow = true
    this.Threshold=[];
  }
  pushAll(){
    this.formData = {
      title:"公共阈值推送",
      model: this.ThresholdList,
    };
    this.patientpushShow = true
  }
  patientpushShowChange() {
			this.patientpushShow = false
			this.getData()
		}
  edit(row:any) {
    this.addOrEdittitle=row.itemName+"阈值设置"
    this.formData = {
      mode: "edit",
      model: row,
      patient:this.patient,
      title:this.addOrEdittitle
    };
		this.addOrEditShow = true
	}
 /* async del(row:any){
    if(this.patient==null){
   await DeleteThresholdSet({itemCode:row.itemCode});
    }else{
    await DeletePatientThresholdSet({itemCode:row.itemCode,PD_Patient_ID:this.patient.pD_Patient_ID})
    }
    this.getData()
  }*/
/*  add() {
    this.addOrEdittitle="添加阈值指标"
    this.formData = {
      mode: "add",
      patient:this.patient,
      title:this.addOrEdittitle
    };
  
    this.addOrEditShow = true;
  }*/
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/tool/publicThreshold/index.vue